var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-type-card flex-column"},[(_vm.srcImg)?_c('img',{staticClass:"order-type-card__ico",class:{'other-hover' : _vm.otherHover},attrs:{"alt":"ico","src":_vm.srcImg}}):_vm._e(),(_vm.text)?_c('div',{staticClass:"order-type-card__text",class:{'mt-2' : _vm.srcImg && _vm.text}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }